import React from 'react';

import scrollTo from '../../../../../utils/scrollTo';

import { Container, ContentContainer, Content, Line, Details } from './styles';

const SlideOne: React.FC = () => {
  return (
    <Container>
      <ContentContainer>
        <Content>
          <Line />

          <h3>BEM VINDO A</h3>
          <h2>KARBON</h2>
          <h1>STUDIO</h1>

          <Details>
            <p>
              Somos um estudio de desenvolvimento de jogos focado em promover
              novas experiências por meio de jogos atrativos e acessíveis.
            </p>
            <button type="button" onClick={() => scrollTo('about-us')}>
              Saiba mais
            </button>
          </Details>
        </Content>
      </ContentContainer>
    </Container>
  );
};

export default SlideOne;
